import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';

export const NoAccess = () => {
  const { signOut } = useAuth();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-8 bg-background">
      <div className="max-w-md text-center space-y-6">
        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-foreground">No Shop Access</h1>
          <p className="text-muted-foreground">
            You don't have access to any shops yet.
          </p>
        </div>
        
        <div className="p-4 bg-muted/50 rounded-lg space-y-2">
          <p className="text-sm font-medium text-foreground">What to do next:</p>
          <ul className="text-sm text-muted-foreground space-y-1 text-left">
            <li>• Contact your shop manager for an invitation</li>
            <li>• Check your email for an invitation link</li>
            <li>• Make sure you're using the correct email address</li>
          </ul>
        </div>

        <Button onClick={() => signOut()} variant="outline" className="w-full">
          Sign Out
        </Button>
      </div>
    </div>
  );
};
